import { render, staticRenderFns } from "./SuggestCafeItem.vue?vue&type=template&id=08db00e6"
import script from "./SuggestCafeItem.vue?vue&type=script&lang=js"
export * from "./SuggestCafeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports